module.exports = __webpack_public_path__ + "static/media/5.4.bd3313b5.zip";